
import React, { PureComponent } from 'react';
import { Download } from '@dbk/ui-icons';
import Spinner from '@dbk/ui-spinner';
import DisplayTime from './get-display-time';

class ReceivedAttachment extends PureComponent {

    state = {
        isDownloading: false
    };

    getContentType = (document) => {
        if (document.toLowerCase().includes('jpg') || document.toLowerCase().includes('png')) {
            return 'Image';
        }

        if (document.toLowerCase().includes('pdf')) {
            return 'Pdf';
        }

        return 'Others';
    }

    onAttachmentClick = (message) => {
        this.setState({ isDownloading: true });
        this
            .props
            .downloadAttachment(message, () => this.setState({ isDownloading: false }));
    }


    render() {
        return (
            <div className="outerPane">
                <div className="innerpaneA-attach-recv" onClick={() => { this.onAttachmentClick(this.props.message) }}>

                    <div className="attach-icon"> <Download width={30} height={30} /></div>
                    {this.state.isDownloading ? <div className="attach-receive-spinner"> <Spinner /> </div> :
                        <div className="attach-icon-text">
                            <div className="ait-upper"> {this.getContentType(this.props.message.message)} </div>
                            <div className="ait-lower"> {this.props.message.message} </div>
                        </div>
                    }
                </div>

                <div className="innerpaneB-attach-recv">
                    <div className="timestamp timestamp-attachment">
                        <DisplayTime dateAndTime={this.props.message.meta} />
                    </div>
                </div>
            </div>
        )
    }
}


export default ReceivedAttachment;
